<template>
  <div class="patient-suggestion">
    {{ patientName }}
  </div>
</template>

<script>
export default {
  name: 'PatientSuggestion',

  props: {
    patientName: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
